<template>
  <div class="full-height">
    <AppHeader />
    <section class="body-top">
      <div class="container">
        <div class="columns">
          <div class="column">
            <h1 class="title is-4">Billing Report</h1>
            <nav class="breadcrumb" aria-label="breadcrumbs">
              <ul>
                <li>
                  <router-link :to="{ name: 'Home' }">
                    <span class="icon is-small">
                      <i class="fas fa-home" aria-hidden="true"></i>
                    </span>
                    <span>Home</span>
                  </router-link>
                </li>
                <li class="is-active">
                  <a href="#" aria-current="page">
                    <span class="icon is-small">
                      <i class="fas fa-file-invoice" aria-hidden="true"></i>
                    </span>
                    <span>Export Report</span>
                  </a>
                </li>
              </ul>
            </nav>
          </div>
          <div class="column is-two-thirds">
            <div class="field has-addons has-addons-right">
              <p class="control">
                <span class="select">
                  <select name="month" v-model="selectedMonth" @change="getMonthlyReport()">
                    <option :value="undefined">--Month--</option>
                    <option value="01">January</option>
                    <option value="02">February</option>
                    <option value="03">March</option>
                    <option value="04">April</option>
                    <option value="05">May</option>
                    <option value="06">June</option>
                    <option value="07">July</option>
                    <option value="08">August</option>
                    <option value="09">September</option>
                    <option value="10">October</option>
                    <option value="11">November</option>
                    <option value="12">December</option>
                  </select>
                </span>
              </p>
              <p class="control">
                <span class="select">
                  <select name="year" v-model="selectedYear" @change="getMonthlyReport()">
                    <option :value="undefined">--Year--</option>
                    <option v-for="year in years" :key="year" :value="year">{{ year }}</option>
                  </select>
                </span>
              </p>
              <p class="control" v-if="$cnc.actor.role == 'admin'">
                <input
                  class="input"
                  type="text"
                  id="accountId"
                  placeholder="Account ID"
                  autocomplete="off"
                  v-model="accountId"
                  @change="getMonthlyReport()"
                />
              </p>
              <p class="control">
                <a class="button is-primary" @click="downloadCSV">Export</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section>
      <!-- v-if="accountId && parseInt(accountId, 10) > 1000000"> -->
      <div class="container">
        <div class="columns">
          <div class="column">
            <h1 class="title is-5">
              <span
                v-if="accountId"
              >{{ accountDetails.company ? accountDetails.company + " (" + accountId + "), " : "" }}</span>
              Month: {{ selectedYear && selectedMonth ? selectedYear + "-" + selectedMonth : "Any"}}
            </h1>
            <cnc-table
              ref="downloadAble"
              v-if="true || (accountId && parseInt(accountId, 10) > 1000000)"
              schema="MonthlyCallReport"
              :columns="visibleColumns"
              :columnLabels="{
                accountId: 'Account #',
                normNumber: 'DID',
                totalCall: 'Calls',
                totalMinutes: 'Minutes',
                totalCost: 'Cost'
              }"
              :extraFields="['accountId', 'month']"
              :filters="{
                month:
                  selectedYear && selectedMonth
                    ? selectedYear.toString() + '-' + selectedMonth.toString()
                    : undefined,
                accountId: accountId || undefined
              }"
              :defaultSort="[{ path: 'accountId', direction: 'ascending' }]"
              :limit="100"
              :config="config"
            />
            <table class="table is-fullwidth invoice-total" v-if="models && models.length">
              <tbody>
                <tr>
                  <td>
                    <strong>Total Minutes:</strong>
                  </td>
                  <td>{{ totalMinutes }}</td>
                </tr>
                <tr>
                  <td>
                    <strong>Total Cost:</strong>
                  </td>
                  <td>${{ roundNumber(totalCost) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
    <AppFooter />
  </div>
</template>

<script>
import prop from "propper";
import autocomplete from "autocompleter";
import AppHeader from "../components/AppHeader";
import AppFooter from "../components/AppFooter";

export default {
  name: "home",
  components: {
    AppHeader,
    AppFooter
  },
  data() {
    return {
      models: null,
      accounts: [],
      accountId: this.$route.params.accountId,
      accountDetails: [],
      selectedYear: prop(this.$route, ["params", "search_date"])
        ? this.$route.params.search_date.split("-")[0]
        : undefined,
      selectedMonth: prop(this.$route, ["params", "search_date"])
        ? this.$route.params.search_date.split("-")[1]
        : undefined,
      config: {
        fields: {
          normNumber: {
            link(model) {
              return {
                name: "Call-history",
                params: {
                  account_id: model.accountId,
                  search_date: model.month,
                  norm_number: model.normNumber
                }
              };
            }
          },
          accountId: {
            link(model) {
              return {
                name: "Billing-report",
                params: {
                  accountId: model.accountId,
                  search_date: model.month
                }
              };
            }
          }
        }
      }
    };
  },
  computed: {
    visibleColumns() {
      let columns = [
        "month",
        "accountId",
        "company",
        "normNumber",
        "totalCall",
        "totalMinutes",
        "totalCost"
      ];
      if (this.selectedMonth && this.selectedYear) {
        columns = columns.filter(item => item !== "month");
      }
      if (this.accountId) {
        columns = columns.filter(item => item !== "accountId");
        columns = columns.filter(item => item !== "company");
      }
      return columns;
    },
    years() {
      let years = [];
      let d = new Date();
      years.push(d.getFullYear());
      do {
        d.setFullYear(d.getFullYear() - 1);
        years.push(d.getFullYear());
      } while (d.getFullYear() !== 2014);
      return years;
    },
    totalMinutes() {
      if (!this.models) {
        return 0;
      }
      const total = this.models.reduce(
        (prev, next) => prev + next.totalMinutes,
        0
      );
      return total;
    },
    totalCost() {
      if (!this.models) {
        return 0;
      }
      const total = this.models.reduce(
        (prev, next) => prev + next.totalCost,
        0
      );
      return total;
    }
  },
  methods: {
    roundNumber(number) {
      return number.toFixed(2);
    },
    async getBillingAccounts() {
      const result = await this.$cnc.load({
        query: `query {
          models: BillingAccountsMany(options:{sort:[{path:"name", direction: ASCENDING}]}) {
            label: name
            value: accountId
          }
        }`
      });

      if (result) {
        this.accounts = result.models.map(({ label, value }) => ({
          label: value + " - " + label,
          value
        }));
      }

      var input = document.getElementById("accountId");
      if (input) {
        this.setAutoComplete(input);
      }
    },
    setAutoComplete(input) {
      var accounts = this.accounts;
      autocomplete({
        minLength: 1,
        input: input,
        emptyMsg: "No account found",

        fetch: function(text, update) {
          text = text.toLowerCase();
          var suggestions = accounts.filter(n =>
            n.label.toLowerCase().includes(text)
          );
          update(suggestions);
        },
        onSelect: item => {
          input.value = item.value;
          this.accountId = item.value;
          this.getMonthlyReport();
        }
      });
    },
    async getAccountDetails() {
      if (!this.accountId) {
        return;
      }
      const result = await this.$cnc.load({
        query: `query ($accountId:ID!) {
            accountDetails:AccountOne(id: $accountId) {
              company
            }
          }`,
        vars: {
          accountId: this.accountId
        }
      });
      this.accountDetails = result.accountDetails;
    },
    async getMonthlyReport() {
      if (!this.accountId) {
        return;
      }
      const result = await this.$cnc.load({
        query: `query ($month:String, $accountId:ID) {
            models:MonthlyCallReportMany(condition: {month:$month, accountId:$accountId}) {
              totalMinutes
              totalCost
            }
          }`,
        vars: {
          month:
            this.selectedYear && this.selectedMonth
              ? `${this.selectedYear}-${this.selectedMonth}`
              : undefined,
          accountId: this.accountId
        }
      });
      this.models = result.models;

      this.getAccountDetails();
    },
    async downloadCSV() {
      this.$refs.downloadAble.downloadCSV(
        `billing-report-${this.accountId}-${this.selectedYear}-${this.selectedMonth}.csv`
      );
    }
  },
  mounted() {
    this.getBillingAccounts();

    window.table = this;
    // Set Default account ID, Month, Year
    this.accountId = this.accountId || this.$cnc.actor.id || undefined;

    this.getMonthlyReport();
  }
};
</script>

<style scoped>
.full-height {
  position: relative;
  display: flex;
  flex-direction: column;
  padding-bottom: 50px;
  min-height: calc(100vh - 52px);
  overflow: hidden;
}

.body-top {
  position: relative;
  margin-bottom: 1.5rem;
}
.body-top .title:not(:last-child) {
  margin-bottom: 0.5rem;
}

/* INVOICE */
.invoice-table tbody > tr > td,
.invoice-total > tbody > tr > td:first-child {
  text-align: right;
}

.invoice-total > tbody > tr > td {
  border: 0 none;
}
.invoice-total > tbody > tr > td:last-child {
  border-bottom: 1px solid #dddddd;
  text-align: center;
  width: 20%;
}
.footer {
  position: absolute;
  bottom: 0;
  width: 100%;
}
</style>

<style>
.autocomplete {
  z-index: 1000;
  overflow: auto;
  background: #03bedb;
  font-size: 0.9rem;
}

.autocomplete > div {
  padding: 4px 4px;
  border-bottom: 1px solid #008da2;
}

.autocomplete .group {
  background: #eee;
}

.autocomplete > div:hover:not(.group),
.autocomplete > div.selected {
  background: #008da2;
  color: #fff;
  cursor: pointer;
}
</style>
